
import http from '@/http';

const setList =  async (context) =>{

     try{

        const data = ( await http.get("/company/dashboard") ).data
        context.commit("SET_LIST",data)


     } catch(err ){
            window.console.log(err)
     }

}

export default {
    setList,
}